var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M22 1H3C1.89543 1 1 1.89543 1 3V15C1 16.1046 1.89543 17 3 17H22C23.1046 17 24 16.1046 24 15V3C24 1.89543 23.1046 1 22 1Z","stroke":"white","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M23.4109 1.58203L12.4999 10.5L1.58887 1.58203","stroke":"white","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Mail.defaultProps = {"width":"25","height":"18","viewBox":"0 0 25 18"};

module.exports = Mail;

Mail.default = Mail;
